import React from 'react';
import { Box } from '@mui/material';
import VoterRollsBanner from '../components/HomePageComponents/VoterRollsBanner';
import HomeSectionOne from '../components/HomePageComponents/HomeSectionOne';
import HomeSectionTwo from '../components/HomePageComponents/HomeSectionTwo';
import HomeSectionFour from '../components/HomePageComponents/HomeSectionFour';
import HomeSectionFive from '../components/HomePageComponents/HomeSectionFive';

const HEADER_H = 72;

const Home = () => {
  return (
    <Box>
      <VoterRollsBanner />
      <Box
        id="section1"
        sx={{
          bgcolor: '#f8f9fa',
          display: 'flex',
          flexDirection: 'column',
          pt: 0,
          pb: 0,
        }}
      >
        <HomeSectionOne />
      </Box>
      <Box
        id="section2"
        sx={{
          bgcolor: 'transparent',
          scrollMarginTop: `${HEADER_H}px`,
        }}
      >
        <HomeSectionTwo />
      </Box>
      <Box id="section4" sx={{ scrollMarginTop: `${HEADER_H}px` }}>
        <HomeSectionFour />
      </Box>
      <Box id="section5">
        <HomeSectionFive />
      </Box>
    </Box>
  );
};

export default Home;
